import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/bleums-logo.png';
import { useHasProducts } from '../hooks/useHasProducts';

const Footer: React.FC = () => {
  const hasProducts = useHasProducts();

  return (
    <footer className="bg-background-dark border-t border-background-dark mt-16 print-hide">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          {/* Full lockup here — there's room for the wordmark to be legible. */}
          <img
            src={logo}
            alt="Bleums Creations"
            className="h-28 w-auto object-contain -ml-1"
          />
          <p className="text-sm text-text-light mt-2 leading-relaxed">
            Sisters + Mamas inspired
            <br />
            Personalized goods for all of life's joys
          </p>
        </div>
        <div>
          {/* Heading follows the contents: with an empty catalog the column
              is only about ordering, so calling it "Shop" points at a shop
              that isn't there. */}
          <div className="font-medium text-sm mb-2">{hasProducts ? 'Shop' : 'Orders'}</div>
          <ul className="space-y-1 text-sm text-text-light">
            {hasProducts && (
              <li><Link to="/shop" className="hover:text-primary">All Products</Link></li>
            )}
            <li><Link to="/custom-request" className="hover:text-primary">Custom Orders</Link></li>
            <li><Link to="/order/status" className="hover:text-primary">Track Order</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-medium text-sm mb-2">About</div>
          <ul className="space-y-1 text-sm text-text-light">
            <li><Link to="/about" className="hover:text-primary">About Us</Link></li>
            <li><Link to="/privacy" className="hover:text-primary">Privacy</Link></li>
            <li><Link to="/terms" className="hover:text-primary">Terms</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-background-dark">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 text-xs text-text-light flex justify-between">
          <span>&copy; {new Date().getFullYear()} Bleums Creations.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
